/* eslint-env node */

module.exports = require('./lib/src/addons/MomentLocaleUtils');
module.exports.localeUtils = require('./lib/src/addons/MomentLocaleUtils');



//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/moment.js
// module id = 280
// module chunks = 4